import SignalMappingComponent from "../signal_mapping";

/**
 * パトランプ(Signallamp Store)設定からパトランプの配色を反映させる処理
 * @param self
 */

export function applySignallampSetting(self: SignalMappingComponent) {
  if (self.mstSignallampSettings) {
    for (const key in self.authStores) {
      if (self.authStoreName === self.authStores[key].store_name) {
        // TODO: auth_storeをローカルで持ちたくないのでAPIにやらせるように要修正
        self.authStore = self.authStores[key];
      }
    }
    if (self.mstSignallampSetting) {
      self.dbTableName = self.mstSignallampSetting.table_name;
      self.location = self.mstSignallampSetting.location;
      self.lampColorAndFlagMap = self.mstSignallampSetting.lamp_color_and_flag_map;
    }
  }
  // 扱い易いようにフラグを取り除いて色だけの配列を作り直す
  self.keyColors = [];
  self.lampColors = [];
  for (const lampColorAndFlag in self.lampColorAndFlagMap) {
    self.keyColors.push(self.lampColorAndFlagMap[lampColorAndFlag].color);
  }
  // 設定されたランプの色を反映
  for (let i = 0; i < 4; i++) {
    const color: string =
      typeof self.keyColors[i] !== "undefined" ? self.keyColors[i] : "#cccccc";
    const className: string =
      typeof self.keyColors[i] !== "undefined" ? `lamp-${color}` : "";
    const backColor = `background-color: ${color}`;
    self.lampColors.push({
      className,
      backColor,
      flush: false,
    });
  }
}
